export default {
    students3d: {
        defaults: {
            endpoint: 'student3D.php',
        },
        read: {
            params: { action: 'get' }
        }
    }
}
